import React from 'react';
import { Skeleton } from '../skeleton/Skeleton';

export const EventCarouselSkeleton = () => {
	return <Skeleton height='306px' width='100%' style={{ borderRadius: '12px' }} />;
};
